<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden p-4 gap-3">
      <p-skeleton width="12rem" height="1.5rem" />
      @for (row of skeletonRows; track row) {
        <div class="flex items-center gap-3">
          <p-skeleton width="8rem" height="0.875rem" />
          <p-skeleton width="12rem" height="0.875rem" />
          <p-skeleton width="5rem" height="1.25rem" />
        </div>
      }
    </div>
  }

  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <mat-icon class="text-red-600 mr-2">error</mat-icon>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button type="button" (click)="load()" class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
              <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                <i class="pi pi-list"></i>
              </span>
              Transacciones bajo demanda
            </h2>
            <p class="text-sm text-slate-500 mt-1">Cargos de registro y cobros bajo demanda de todos los mandatos.</p>
          </div>
          <p-button label="Actualizar" icon="pi pi-refresh" severity="secondary" size="small" [rounded]="true"
            [loading]="loading()" (onClick)="load()" />
        </div>
      </div>

      <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
        <div class="grid grid-cols-2 xl:flex xl:flex-wrap xl:items-end gap-2">
          <p-floatlabel class="w-full min-w-0 xl:w-44" variant="on">
            <p-select formControlName="status" inputId="mitTxStatus" [options]="statusOptions" optionLabel="label" optionValue="value"
              size="small" [showClear]="true" class="w-full" />
            <label for="mitTxStatus">Estado</label>
          </p-floatlabel>
          <p-floatlabel class="w-full min-w-0 xl:w-44" variant="on">
            <p-select formControlName="type" inputId="mitTxType" [options]="typeOptions" optionLabel="label" optionValue="value"
              size="small" [showClear]="true" class="w-full" />
            <label for="mitTxType">Tipo</label>
          </p-floatlabel>
          <div class="min-w-0 col-span-2 sm:col-span-1 xl:flex-1 xl:min-w-48">
            <p-floatlabel class="w-full" variant="on">
              <p-autocomplete
                inputId="mitTxCustomer"
                formControlName="customer"
                [suggestions]="customerOptions()"
                (completeMethod)="onCustomerSearch($event)"
                (onSelect)="applyFilters()"
                (onClear)="applyFilters()"
                optionLabel="displayLabel"
                [minLength]="3"
                [showClear]="true"
                size="small"
                fluid
                appendTo="body">
                <ng-template #item let-customer>
                  <div class="flex flex-col py-0.5">
                    <span class="text-sm font-medium text-slate-900 leading-snug">{{ customer.comercialName || customer.legalName }}</span>
                    <span class="text-xs text-slate-400 leading-snug">{{ customer.taxId }}</span>
                  </div>
                </ng-template>
              </p-autocomplete>
              <label for="mitTxCustomer">Cliente</label>
            </p-floatlabel>
          </div>
          <p-floatlabel class="w-full min-w-0 xl:w-32" variant="on">
            <input pInputText id="mitTxMandate" formControlName="mandateNumber" class="w-full p-inputtext-sm" autocomplete="off" />
            <label for="mitTxMandate">Mandato</label>
          </p-floatlabel>
          <p-floatlabel class="w-full min-w-0 xl:w-40" variant="on">
            <input pInputText id="mitTxRef" formControlName="externalReference" class="w-full p-inputtext-sm" autocomplete="off" />
            <label for="mitTxRef">Referencia</label>
          </p-floatlabel>
          <p-floatlabel class="w-full min-w-0 col-span-2 sm:col-span-1 xl:w-64" variant="on">
            <p-datepicker inputId="mitTxCreatedAt" formControlName="createdAtRange" selectionMode="range" [readonlyInput]="true"
              dateFormat="dd/mm/yy" showIcon iconDisplay="input" [showClear]="true" size="small" appendTo="body" class="w-full" />
            <label for="mitTxCreatedAt">Rango de fechas</label>
          </p-floatlabel>
          @if (hasActiveFilters()) {
            <div class="flex items-end">
              <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" severity="secondary" type="button"
                (onClick)="clearFilters()" ariaLabel="Limpiar filtros" />
            </div>
          }
        </div>
      </div>

      <div class="flex-1 min-h-0 overflow-hidden">
        <p-table
          [value]="transactions()"
          dataKey="id"
          [lazy]="true"
          [scrollable]="true"
          scrollHeight="flex"
          [totalRecords]="totalItems()"
          [first]="currentPage() * pageSize()"
          [rows]="pageSize()"
          [rowsPerPageOptions]="pageSizeOptions"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} transacciones"
          [loading]="loading()"
          [paginator]="true"
          sortMode="single"
          [sortField]="sortField()"
          [sortOrder]="sortOrder()"
          (onLazyLoad)="onLazyLoad($event)"
          styleClass="mit-table p-datatable-striped p-datatable-sm"
          [rowHover]="true"
          paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !items-center !justify-between">
          <ng-template pTemplate="paginatorleft">
            <span
              class="inline-flex"
              [pTooltip]="exportButtonTooltip"
              tooltipPosition="top"
              appendTo="body">
              <p-button
                label="Exportar CSV"
                icon="pi pi-download"
                severity="secondary"
                size="small"
                [rounded]="true"
                [loading]="exporting()"
                [disabled]="!canExportTransactions || exporting() || totalItems() === 0"
                (onClick)="exportCsv()" />
            </span>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="!px-2 !text-center" pSortableColumn="createdAt">Fecha <p-sortIcon field="createdAt" /></th>
              <th class="!px-2">Mandato</th>
              <th class="!px-2">Cliente</th>
              <th class="!px-2 hidden md:table-cell">Tipo</th>
              <th class="!px-2" pSortableColumn="status">Estado <p-sortIcon field="status" /></th>
              <th class="!px-2 hidden lg:table-cell">Concepto</th>
              <th class="!px-2 hidden md:table-cell">Referencia</th>
              <th class="!px-2 !text-right" pSortableColumn="amount">Monto <p-sortIcon field="amount" /></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-tx>
            <tr class="cursor-pointer hover:!bg-sky-50/50 transition-colors" (click)="open(tx)">
              <td class="!px-2 !py-2 !text-center !whitespace-nowrap">
                <div class="text-sm text-slate-600">{{ tx.createdAt | date:'dd/MM/yyyy' }}</div>
                <div class="text-[11px] text-slate-400 mt-0.5">{{ tx.createdAt | date:'h:mm a' }}</div>
              </td>
              <td class="!px-2 !py-2 text-sm font-medium text-slate-900 !whitespace-nowrap">{{ tx.mandateNumber }}</td>
              <td class="!px-2 !py-2 max-w-[12rem] text-sm text-slate-900 truncate">{{ tx.customerName || '—' }}</td>
              <td class="!px-2 !py-2 hidden md:table-cell text-sm text-slate-700">{{ typeLabel(tx.type) }}</td>
              <td class="!px-2 !py-2">
                <p-tag class="!text-xs" [severity]="statusSeverity(tx.status)" [value]="statusLabel(tx.status)" />
                @if (detail(tx)) {
                  <span class="block text-[11px] text-slate-500 mt-0.5 max-w-[14rem] truncate">{{ detail(tx) }}</span>
                }
              </td>
              <td class="!px-2 !py-2 hidden lg:table-cell max-w-[14rem] text-sm text-slate-700 truncate">{{ tx.concept }}</td>
              <td class="!px-2 !py-2 hidden md:table-cell text-sm text-slate-700">{{ tx.externalReference || '—' }}</td>
              <td class="!px-2 !py-2 !text-right !whitespace-nowrap text-sm text-slate-900">
                {{ tx.amount | currency:(tx.currencyCode || 'MXN'):'symbol-narrow':'1.2-2' }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8" class="!px-2 !py-12 !text-center !text-slate-500">No se encontraron transacciones con los filtros aplicados.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
</div>

  <p-drawer
    [visible]="isDetailsOpen()"
    position="right"
    (visibleChange)="onDrawerVisibleChange($event)"
    styleClass="mit-transaction-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
            <i class="pi pi-credit-card text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalle de transacción</h3>
        </div>
        @if (selectedTransactionId()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="goToDetail()">
            <i class="pi pi-external-link text-sm"></i>
            Ir al detalle
          </button>
        }
      </div>
    </ng-template>
    @if (selectedTransactionId(); as id) {
      <app-mit-transaction-read
        [transactionId]="id"
        [embedded]="true"
        (changed)="onTransactionChanged($event)" />
    }
  </p-drawer>
</div>
